// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-extra .v-btn,.banner-extra .v-btn__content{max-width:100%;white-space:normal;height:auto!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
